import { merchantApi } from '@/config/axios'
import type { PresaleDepositCancelVO } from '@/api/mall/trade/presaleDepositCancel'

export type { PresaleDepositCancelVO }

export {
  DEPOSIT_CANCEL_STATUS,
  getDepositCancelStatusLabel
} from '@/api/mall/trade/presaleDepositCancel'

export const getDepositCancelPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/trade/presale-deposit-cancel/page', params })
}

export const getDepositCancel = (id: number) => {
  return merchantApi.get({ url: '/merchant-api/trade/presale-deposit-cancel/get', params: { id } })
}

/** auditResult: 1通过退定金 2通过不退 3驳回 */
export const auditDepositCancel = (data: {
  id: number
  auditResult: number
  auditReason?: string
}) => {
  return merchantApi.put({ url: '/merchant-api/trade/presale-deposit-cancel/audit', data })
}
